export const IPolybitThemeFactory = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_polybitThemeAccessAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "_polybitThemeConfigAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "_polybitThemeAddress",
                "type": "address"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor",
        "name": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "string",
                "name": "msg",
                "type": "string"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "ref",
                "type": "address"
            }
        ],
        "name": "ThemeContractCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "_walletOwner",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_productId",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_lockTimestamp",
                        "type": "uint256"
                    },
                    {
                        "components": [
                            {
                                "internalType": "address[]",
                                "name": "sellList",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "sellListPrices",
                                "type": "uint256[]"
                            },
                            {
                                "components": [
                                    {
                                        "internalType": "address[]",
                                        "name": "factory",
                                        "type": "address[]"
                                    },
                                    {
                                        "internalType": "address[][]",
                                        "name": "path",
                                        "type": "address[][]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsIn",
                                        "type": "uint256[]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsOut",
                                        "type": "uint256[]"
                                    }
                                ],
                                "internalType": "struct PolybitTheme.SwapOrder[]",
                                "name": "sellOrders",
                                "type": "tuple[]"
                            },
                            {
                                "internalType": "address[]",
                                "name": "adjustList",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "adjustListPrices",
                                "type": "uint256[]"
                            },
                            {
                                "internalType": "address[]",
                                "name": "adjustToSellList",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "adjustToSellPrices",
                                "type": "uint256[]"
                            },
                            {
                                "components": [
                                    {
                                        "internalType": "address[]",
                                        "name": "factory",
                                        "type": "address[]"
                                    },
                                    {
                                        "internalType": "address[][]",
                                        "name": "path",
                                        "type": "address[][]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsIn",
                                        "type": "uint256[]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsOut",
                                        "type": "uint256[]"
                                    }
                                ],
                                "internalType": "struct PolybitTheme.SwapOrder[]",
                                "name": "adjustToSellOrders",
                                "type": "tuple[]"
                            },
                            {
                                "internalType": "address[]",
                                "name": "adjustToBuyList",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "adjustToBuyWeights",
                                "type": "uint256[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "adjustToBuyPrices",
                                "type": "uint256[]"
                            },
                            {
                                "components": [
                                    {
                                        "internalType": "address[]",
                                        "name": "factory",
                                        "type": "address[]"
                                    },
                                    {
                                        "internalType": "address[][]",
                                        "name": "path",
                                        "type": "address[][]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsIn",
                                        "type": "uint256[]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsOut",
                                        "type": "uint256[]"
                                    }
                                ],
                                "internalType": "struct PolybitTheme.SwapOrder[]",
                                "name": "adjustToBuyOrders",
                                "type": "tuple[]"
                            },
                            {
                                "internalType": "address[]",
                                "name": "buyList",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "buyListWeights",
                                "type": "uint256[]"
                            },
                            {
                                "internalType": "uint256[]",
                                "name": "buyListPrices",
                                "type": "uint256[]"
                            },
                            {
                                "components": [
                                    {
                                        "internalType": "address[]",
                                        "name": "factory",
                                        "type": "address[]"
                                    },
                                    {
                                        "internalType": "address[][]",
                                        "name": "path",
                                        "type": "address[][]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsIn",
                                        "type": "uint256[]"
                                    },
                                    {
                                        "internalType": "uint256[]",
                                        "name": "amountsOut",
                                        "type": "uint256[]"
                                    }
                                ],
                                "internalType": "struct PolybitTheme.SwapOrder[]",
                                "name": "buyOrders",
                                "type": "tuple[]"
                            }
                        ],
                        "internalType": "struct PolybitTheme.SwapOrders[]",
                        "name": "_orderData",
                        "type": "tuple[]"
                    }
                ],
                "internalType": "struct PolybitThemeFactory.CreateThemeParameters",
                "name": "createParams",
                "type": "tuple"
            }
        ],
        "name": "createThemeContract",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getListOfThemeContracts",
        "outputs": [
            {
                "internalType": "address[]",
                "name": "",
                "type": "address[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_walletOwner",
                "type": "address"
            }
        ],
        "name": "getThemeContracts",
        "outputs": [
            {
                "internalType": "address[]",
                "name": "",
                "type": "address[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "polybitThemeAccessAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "polybitThemeAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "polybitThemeConfigAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
] as const